"use strict";

angular.module("vendor")
.component("saleRepresentativeManageSection", {
    bindings: {
        userVendor: "="
    },
    templateUrl: require("./sale-representative-manage-section.component.html"),
    controllerAs: "ManageSectionCtrl",
    controller: controller
});

function controller(
    $scope, $controller, ModalService, SaleRepresentativeAssignedFactory, PartnershipStatusFilterService,
    PartnershipTagService
) {
    angular.extend(this, $controller("AbstractSaleRepresentativeEditController", {_this: this, $scope: $scope}));
    var _this = this;
    var currentSort;

    $scope.tagFilterService = PartnershipTagService;
    $scope.statusFilterService = PartnershipStatusFilterService;

    $scope.saleRepresentativeAssignedFactory = SaleRepresentativeAssignedFactory;
    $scope.pagination = {};
    $scope.statusesValues = $scope.statusFilterService.query({statuses: "disabled,invited,valid,has_ordered"});
    $scope.filters = {};

    this.searchTerm = "";

    $scope.tagFilterParameter = {user_vendor: this.userVendor.id};
    $scope.$on("tagFilterUpdated", function(event, tagsFilter) {
        angular.extend($scope.filters, tagsFilter);
        _this.clearSelection();
    });

    $scope.$on("statusDateFilterUpdated", function(event, statusFilter) {
        $scope.assignedSalesRepForm.$setDirty(statusFilter.status); // Avoid the list to be hidden when no results
        angular.extend($scope.filters, statusFilter);
        _this.clearSelection();
    });

    this.query = function() {
        var search = this.searchTerm;
        var userVendor = this.userVendor.id;
        var sort = currentSort;
        var page = $scope.pagination.current_page;

        $scope.service.queryAssigned(userVendor, search, page, sort, $scope.filters)
        .$promise.then(function onSuccess(data) {
            $scope.setCheckboxState(data, $scope);
            $scope.pagination = data.pagination;
            $scope.instances = data.results;
        });
    };

    this.onDeleteAssigned = function() {
        _this.resetListings();
    };

    this.onUpdateSort = function(sort) {
        currentSort = sort;
        _this.query();
    };

    this.resetListings = function() {
        $scope.$emit("requestResetListing");
    };

    $scope.$on("resetListing", function($event) {
        $scope.filters.tags = null;
        $scope.$broadcast("queryFilter");
        _this.query();
    });

    this.refreshOnBulkAction = function() {
        this.resetListings();
    };


    this.updateSelection = function(selected) {
        var search = this.searchTerm;
        var sort = currentSort;
        var page = $scope.pagination.current_page;

        $scope.service.updateAssignedAllSelected(this.userVendor.id, search, selected, sort, page, $scope.filters)
        .$promise.then(function onSuccess(data) {
            $scope.instances = data.results;
            $scope.setCheckboxState(data, $scope);
        });
    };

    this.clearSelection = function() {
        $scope.service.updateAssignedAllSelected(_this.userVendor.id, undefined, false, undefined, 1, {})
        .$promise.then(function onSuccess() {
            _this.query();
        });
    };

    $scope.$on("clearSelection", function() {
        _this.clearSelection();
    });

    this.selectSingle = function(instance) {
        $scope.updateSingle(instance, $scope.service.updateAssignedSingleSelected, $scope);
    };

    this.clearSelection();
}



//////////////////
// WEBPACK FOOTER
// ./vendor/sections/sale-representative/manage-section/sale-representative-manage-section.component.js
// module id = 1007
// module chunks = 0